import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

const TablePagination = props => {

  const defaultButton = props => (
    <button type="button" {...props} className="-btn">
      {props.children}
    </button>
  )

  const {
    // Computed
    pages,
    // Props
    showPageSizeOptions,
    pageSizeOptions,
    pageSize,
    data,
    showPageJump,
    canNextFromData,
    onPageSizeChange,
    className,
    PreviousComponent = defaultButton,
    NextComponent = defaultButton,
    showTotalPages = true,
    currentPage
  } = props

  const [page,setPage] = React.useState(null)
  
  React.useEffect(()=>{
    setPage(currentPage-1)
  },[currentPage])
  
  const canNext = (pages-page) != 1

  const canPrevious = data && (page != 0&&page != null)

  function getSafePage (inPage) {
    if (isNaN(inPage)) {
      inPage = props.page
    }
    if (canNextFromData)
      return inPage

    return Math.min(Math.max(inPage, 0), pages - 1)
  }

  function changePage (page) {
    page = getSafePage(page)
    setPage(page)
    if (page !== props.page||page == 0) {
      props.onPageChange(page)
    }
  }

  function applyPage (e) {
    if (e) { e.preventDefault() }
    const inPage = page
    changePage(inPage === '' ? props.page : inPage)
  }

  return (
    <div
      className={classnames(className, '-pagination')}
      style={props.style}
    >
      <div className="-previous">
        <PreviousComponent
          onClick={() => {
            if (!canPrevious) return
            changePage(page - 1)
          }}
          disabled={!canPrevious}
        >
          {props.previousText}
        </PreviousComponent>
      </div>
      <div className="-center">
        <span className="-pageInfo">
          {/* {props.pageText}{' '} */}

          {showPageJump? 
            <div className="-pageJump">
              <input
                type={page === '' ? 'text' : 'number'}
                onChange={e => {
                  const val = e.target.value
                  const page = val - 1
                  if (val === '') {
                    return setPage(val)
                  }
                  setPage(getSafePage(page))
                }}
                value={page === '' ? '' : page + 1}
                onBlur={(e)=>applyPage()}
                onKeyPress={e => {
                  if (e.which === 13 || e.keyCode === 13) {
                    applyPage()
                  }
                }}
              />
            </div>
            : 
            <span className="-currentPage">
              {page + 1}
            </span>
          }{' '}
          {showTotalPages
          ?
            <React.Fragment>
              {props.ofText}{' '}
              <span className="-totalPages">{pages || 1}</span>
            </React.Fragment>
          : null}
        </span>
        {showPageSizeOptions &&
          <span className="select-wrap -pageSizeOptions">
            <select
              onChange={e => {localStorage.setItem('userPageSize', Number(e.target.value));onPageSizeChange(Number(e.target.value))}}
              value={pageSize}
            >
              {pageSizeOptions.map((option, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <option key={i} value={option}>
                  {option} {props.rowsText}
                </option>
              ))}
            </select>
          </span>}
      </div>
      <div className="-next">
        <NextComponent
          onClick={() => {
            if (!canNext) return
            changePage(page + 1)
          }}
          disabled={!canNext}
        >
          {props.nextText}
        </NextComponent>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(TablePagination)
